// src/components/auth/AuthModals.jsx
import React from 'react';
import CreateAccountModal from './CreateAccountModal';
import SignInModal from './SignInModal';
import ResetPasswordModal from './ResetPasswordModal';
import { useModal } from '../../context/ModalContext';

const AuthModals = () => {
  // ✅ grab modalData too
  const { activeModal, modalData, closeModal, openModal } = useModal();

  const handleSwitchToSignIn = () => {
    // preserve redirectTo when switching tabs
    openModal('signin', modalData);
  };

  const handleSwitchToCreateAccount = () => {
    openModal('create', modalData);
  };

  const handleSwitchToResetPassword = () => {
    openModal('reset', modalData);
  };

  return (
    <>
      {activeModal === 'create' && (
        <CreateAccountModal
          onClose={closeModal}
          onSwitchToSignIn={handleSwitchToSignIn}
          redirectTo={modalData?.redirectTo} // ✅
        />
      )}

      {activeModal === 'signin' && (
        <SignInModal
          onClose={closeModal}
          onSwitchToCreateAccount={handleSwitchToCreateAccount}
          onSwitchToResetPassword={handleSwitchToResetPassword}
          redirectTo={modalData?.redirectTo} // ✅
        />
      )}

      {activeModal === 'reset' && (
        <ResetPasswordModal
          onClose={closeModal}
          onSwitchToSignIn={handleSwitchToSignIn}
        />
      )}
    </>
  );
};

export default AuthModals;